"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasResolvedComments = exports.getCommentCounts = exports.getFilteredComments = exports.getFilterableUsers = void 0;

var _reselect = require("reselect");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.keyby"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getComments = function getComments(state) {
  return (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.comments"));
};

var getFilterTime = function getFilterTime(state) {
  return (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.filterTime"));
};

var getFilterUsers = function getFilterUsers(state) {
  return (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.filterUsers"));
};

var getGlobalCommentsUnmapped = function getGlobalCommentsUnmapped(_) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props.globalCommentsUnmapped;
};

var getGlobalCommentsToggle = function getGlobalCommentsToggle(_) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props.globalCommentsToggle.isActive;
};

var getRegisteredSectionIds = function getRegisteredSectionIds(state) {
  return (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.registeredSectionIds"));
};

var getShowResolvedComments = function getShowResolvedComments(state) {
  return (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showResolvedComments"));
};

var getAnnotationsMultiPageEnabled = function getAnnotationsMultiPageEnabled(_) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props.annotationsMultiPageEnabled;
};

var getAssetData = function getAssetData(_) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props.assetData;
};

var getGlobalComments = function getGlobalComments(_) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props.globalComments;
};

var getAnyFilterEnabled = function getAnyFilterEnabled(state) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var showResolvedComments = props.compactLayout ? false : (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showResolvedComments"));
  var filterTime = getFilterTime(state) || [];
  var filterUsers = getFilterUsers(state) || [];
  return props.filterComments && (filterTime.length > 0 || filterUsers.length > 0 || showResolvedComments);
};

var cleanComment = function cleanComment(comment) {
  delete comment.pinNum;
  delete comment.hasShapeAnnotation;
  delete comment.hasHighlightAnnotation;
  delete comment.hasInsertAnnotation;
  delete comment.hasReplaceAnnotation;
  delete comment.hasStrikethroughAnnotation;
};

var addAnnotationMarkers = function addAnnotationMarkers(list, showResolvedComments, registeredSectionIds, usingGlobalComments, assetData, annotationsMultiPageEnabled) {
  var pinCounter = 1;
  return list.filter(function (comment) {
    var isValid = !comment.unmapped && (showResolvedComments ? comment.status === 'resolved' : comment.status === 'open');
    var sectionId = (0, _lodash.default)(comment, 'target.selector.sectionId') || 'root';
    var curSelectionSubtype = (0, _lodash.default)(comment, 'target.selector.subtype');
    var matchesActiveNode = assetData.nodeId === (0, _lodash.default)(comment, 'target.selector.node.id');

    if (isValid && (0, _lodash.default)(comment, 'target.selector.noteX') && curSelectionSubtype === 'note' && registeredSectionIds.indexOf(sectionId) > -1 && (!usingGlobalComments || matchesActiveNode || annotationsMultiPageEnabled)) {
      comment.pinNum = pinCounter;
      pinCounter++;
    } else if (isValid && curSelectionSubtype === 'shape' && registeredSectionIds.indexOf(sectionId) > -1 && (!usingGlobalComments || matchesActiveNode || annotationsMultiPageEnabled)) {
      comment.hasShapeAnnotation = true;
    } else if (isValid && curSelectionSubtype === 'highlight' && registeredSectionIds.indexOf(sectionId) > -1 && (!usingGlobalComments || matchesActiveNode || annotationsMultiPageEnabled)) {
      comment.hasHighlightAnnotation = true;
    } else if (isValid && curSelectionSubtype === 'strikethrough' && registeredSectionIds.indexOf(sectionId) > -1 && (!usingGlobalComments || matchesActiveNode || annotationsMultiPageEnabled)) {
      comment.hasStrikethroughAnnotation = true;
    } else if (isValid && curSelectionSubtype === 'replace' && registeredSectionIds.indexOf(sectionId) > -1 && (!usingGlobalComments || matchesActiveNode || annotationsMultiPageEnabled)) {
      comment.hasReplaceAnnotation = true;
    } else if (isValid && curSelectionSubtype === 'insert' && registeredSectionIds.indexOf(sectionId) > -1 && (!usingGlobalComments || matchesActiveNode || annotationsMultiPageEnabled)) {
      comment.hasInsertAnnotation = true;
    } else {
      cleanComment(comment);
    }

    return isValid;
  });
};
/**
 * Returns valid comments based on asset data or host config.
 * @return {array} a list of valid comments to work with
 */


var getValidComments = (0, _reselect.createSelector)([getAssetData, getComments, getGlobalComments, getGlobalCommentsUnmapped], function (assetData) {
  var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var globalComments = arguments.length > 2 ? arguments[2] : undefined;
  var globalCommentsUnmapped = arguments.length > 3 ? arguments[3] : undefined;

  if (globalComments && assetData.validNodes) {
    var validNodeIds = assetData.validNodes.map(function (_ref) {
      var id = _ref.id;
      return id;
    });
    var validComments = [];
    var unmappedComments = [];
    comments.forEach(function (comment) {
      var commentNodeId = (0, _lodash.default)(comment, 'target.selector.node.id');

      if (assetData.useNodeIndex && commentNodeId >= 0 && commentNodeId < assetData.validNodes.length || !assetData.useNodeIndex && validNodeIds.includes(commentNodeId)) {
        delete comment.unmapped;
        validComments.push(comment);
      } else if (globalCommentsUnmapped) {
        comment.unmapped = true;
        unmappedComments.push(comment);
      }
    });
    return validComments.concat(unmappedComments);
  } // host using nodes


  if (assetData.nodeId !== undefined) {
    return comments.filter(function (comment) {
      return (0, _lodash.default)(comment, 'target.selector.node.id');
    });
  }

  return comments;
});
/**
 * Returns a list of users that have reachable comments.
 * @return {array} a list of users used for filtering comments
 */

var getFilterableUsers = (0, _reselect.createSelector)([getValidComments], function () {
  var comments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filterableUsers = [];
  var userMap = {};
  comments.forEach(function (_ref2) {
    var _ref2$creator = _ref2.creator,
        creator = _ref2$creator === void 0 ? {} : _ref2$creator;
    var email = creator.email; // signed in users

    if (email && !userMap[email]) {
      filterableUsers.push(creator);
      userMap[email] = email;
    } // guest users


    if (!email && !userMap[creator.name]) {
      filterableUsers.push(creator);
      userMap[creator.name] = creator.name;
    }
  });
  return filterableUsers.sort(function (sortA, sortB) {
    var thisName = sortA.name || '';
    var thatName = sortB.name || '';
    return thisName.localeCompare(thatName);
  });
});
/**
 * Function to return a derived state of the comments array
 * @returns {array} list of comments filtered by options
 */

exports.getFilterableUsers = getFilterableUsers;
var getFilteredComments = (0, _reselect.createSelector)([getAssetData, getComments, getFilterTime, getFilterUsers, getGlobalComments, getRegisteredSectionIds, getShowResolvedComments, getGlobalCommentsToggle, getFilterableUsers, getGlobalCommentsUnmapped, getAnnotationsMultiPageEnabled], function (assetData, comments) // eslint-disable-next-line max-params
{
  var filterTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var filterUsers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var globalComments = arguments.length > 4 ? arguments[4] : undefined;
  var registeredSectionIds = arguments.length > 5 ? arguments[5] : undefined;
  var showResolvedComments = arguments.length > 6 ? arguments[6] : undefined;
  var isGlobalCommentsToggleActive = arguments.length > 7 ? arguments[7] : undefined;
  var filterableUsers = arguments.length > 8 ? arguments[8] : undefined;
  var globalCommentsUnmapped = arguments.length > 9 ? arguments[9] : undefined;
  var annotationsMultiPageEnabled = arguments.length > 10 ? arguments[10] : undefined;
  var filteredComments = comments ? comments.concat([]) : [];
  var usingGlobalComments = globalComments && isGlobalCommentsToggleActive;
  var unmappedComments = [];

  if (filterUsers.length > 0) {
    var filterableUsersById = (0, _lodash2.default)(filterableUsers, 'id');
    filteredComments = filteredComments.filter(function (comment) {
      return filterUsers.find(function (id) {
        var user = filterableUsersById[id];

        if (user) {
          if (user.email === '') {
            var commentCreatorIsGuest = !comment.creator.email || comment.creator.email === 'None';
            return commentCreatorIsGuest && user.name === comment.creator.name;
          }

          return user.id === comment.creator.id;
        }

        return false;
      }) !== undefined;
    });
  }

  if (filterTime.length > 0) {
    var includeToday = filterTime.indexOf('today') !== -1;
    var includeYesterday = filterTime.indexOf('yesterday') !== -1;
    var includeLast7Days = filterTime.indexOf('last7Days') !== -1;
    var includeOlder = filterTime.indexOf('older') !== -1;
    var everythingIncluded = (includeToday && includeYesterday || includeLast7Days) && includeOlder;

    if (!everythingIncluded) {
      var dateTodayZeroHourValue = new Date().setHours(0, 0, 0, 0);
      var dateYesterdayZeroHourValue = dateTodayZeroHourValue - 60 * 60 * 24 * 1000;
      var dateLast7DaysValue = new Date().getTime() - 7 * 60 * 60 * 24 * 1000;
      filteredComments = filteredComments.filter(function (comment) {
        var commentModifiedDateValue = new Date(comment.modified).getTime();
        var diffFromToday = commentModifiedDateValue - dateTodayZeroHourValue;
        var diffFromYesterday = commentModifiedDateValue - dateYesterdayZeroHourValue;
        var diffFromLast7Days = commentModifiedDateValue - dateLast7DaysValue;
        return includeLast7Days && diffFromLast7Days >= 0 || includeToday && diffFromToday >= 0 || includeYesterday && diffFromYesterday >= 0 && diffFromToday < 0 || includeOlder && diffFromLast7Days < 0;
      });
    }
  }

  if (usingGlobalComments && assetData.validNodes && assetData.nodeId !== undefined) {
    var globalOrder = [];
    assetData.validNodes.forEach(function (curNode, idx) {
      var validNodeValue = assetData.useNodeIndex ? idx : curNode.id;
      var result = filteredComments.filter(function (itm) {
        return validNodeValue === (0, _lodash.default)(itm, 'target.selector.node.id');
      });

      if (annotationsMultiPageEnabled) {
        result = result.reverse();
      } else {
        result = addAnnotationMarkers(result, showResolvedComments, registeredSectionIds, usingGlobalComments, assetData, annotationsMultiPageEnabled);
      }

      globalOrder = globalOrder.concat(result);
    });

    if (annotationsMultiPageEnabled) {
      globalOrder = addAnnotationMarkers(globalOrder.reverse(), showResolvedComments, registeredSectionIds, usingGlobalComments, assetData, annotationsMultiPageEnabled);
    } // Identify and save unmapped comments


    filteredComments.forEach(function (itm) {
      if (!globalOrder.find(function (cmt) {
        return cmt.id === itm.id;
      })) {
        if (globalCommentsUnmapped && (showResolvedComments && itm.status === 'resolved' || !showResolvedComments && itm.status === 'open')) {
          itm.unmapped = true;
          cleanComment(itm);
          unmappedComments.push(itm);
        } else {
          delete itm.unmapped;
        }
      }
    });
    filteredComments = globalOrder;
  } else if (assetData.nodeId !== undefined) {
    filteredComments = filteredComments.filter(function (itm) {
      return assetData.nodeId === (0, _lodash.default)(itm, 'target.selector.node.id');
    });
  }

  if (!usingGlobalComments) {
    filteredComments = addAnnotationMarkers(filteredComments, showResolvedComments, registeredSectionIds, usingGlobalComments, assetData);
  } // Sort newest to oldest


  filteredComments.reverse();

  if (unmappedComments.length) {
    unmappedComments.reverse();
    filteredComments = filteredComments.concat(unmappedComments);
  }

  return filteredComments;
});
/**
 * Function to return an object containing counts of comments
 * @returns {object} object containing count of total and current node comments along with visible counts
 */

exports.getFilteredComments = getFilteredComments;
var getCommentCounts = (0, _reselect.createSelector)([getAssetData, getComments, getFilteredComments, getAnyFilterEnabled, getGlobalComments, getGlobalCommentsToggle, getGlobalCommentsUnmapped], function (assetData) // eslint-disable-next-line max-params
{
  var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var filteredComments = arguments.length > 2 ? arguments[2] : undefined;
  var anyFilterEnabled = arguments.length > 3 ? arguments[3] : undefined;
  var globalComments = arguments.length > 4 ? arguments[4] : undefined;
  var isGlobalCommentsToggleActive = arguments.length > 5 ? arguments[5] : undefined;
  var globalCommentsUnmapped = arguments.length > 6 ? arguments[6] : undefined;
  var filterCommentsMap = {};
  filteredComments.forEach(function (comment) {
    filterCommentsMap[comment.id] = true;
  });
  var validNodeMap = {};

  if (globalComments && assetData.validNodes && assetData.nodeId !== undefined) {
    assetData.validNodes.forEach(function (node) {
      validNodeMap[node.id] = true;
    });
  }

  var allNodes = {};
  var allNodesWithFilters = {};
  var initCount = {
    resolved: 0,
    unresolved: 0,
    total: 0
  };

  var total = _objectSpread({}, initCount);

  var visible = _objectSpread({}, initCount);

  comments.forEach(function (comment) {
    if (comment.status === 'resolved') {
      total.resolved++;

      if (filterCommentsMap[comment.id]) {
        visible.resolved++;
      }
    }

    if (comment.status === 'open') {
      total.unresolved++;

      if (filterCommentsMap[comment.id]) {
        visible.unresolved++;
      }
    }

    total.total = total.resolved + total.unresolved;
    visible.total = visible.resolved + visible.unresolved;
    var nodeId = (0, _lodash.default)(comment, 'target.selector.node.id');
    var unmapped = globalCommentsUnmapped && !validNodeMap[nodeId];

    if (nodeId !== undefined && !unmapped) {
      if (allNodes[nodeId] === undefined) {
        allNodes[nodeId] = _objectSpread({}, initCount);
      }

      if (allNodesWithFilters[nodeId] === undefined && filterCommentsMap[comment.id]) {
        allNodesWithFilters[nodeId] = _objectSpread({}, initCount);
      }

      if (comment.status === 'open') {
        allNodes[nodeId].unresolved++;

        if (filterCommentsMap[comment.id]) {
          allNodesWithFilters[nodeId].unresolved++;
        }
      } else if (comment.status === 'resolved') {
        allNodes[nodeId].resolved++;

        if (filterCommentsMap[comment.id]) {
          allNodesWithFilters[nodeId].resolved++;
        }
      }

      allNodes[nodeId].total = allNodes[nodeId].unresolved + allNodes[nodeId].resolved;

      if (filterCommentsMap[comment.id]) {
        allNodesWithFilters[nodeId].total = allNodesWithFilters[nodeId].unresolved + allNodesWithFilters[nodeId].resolved;
      }
    } else {
      if (allNodes[_constants.UNMAPPED_GLOBAL_ID] === undefined) {
        allNodes[_constants.UNMAPPED_GLOBAL_ID] = _objectSpread({}, initCount);
      }

      if (allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID] === undefined && filterCommentsMap[comment.id]) {
        allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID] = _objectSpread({}, initCount);
      }

      if (comment.status === 'open') {
        allNodes[_constants.UNMAPPED_GLOBAL_ID].unresolved++;

        if (filterCommentsMap[comment.id]) {
          allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID].unresolved++;
        }
      } else if (comment.status === 'resolved') {
        allNodes[_constants.UNMAPPED_GLOBAL_ID].resolved++;

        if (filterCommentsMap[comment.id]) {
          allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID].resolved++;
        }
      }

      allNodes[_constants.UNMAPPED_GLOBAL_ID].total = allNodes[_constants.UNMAPPED_GLOBAL_ID].unresolved + allNodes[_constants.UNMAPPED_GLOBAL_ID].resolved;

      if (filterCommentsMap[comment.id]) {
        allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID].total = allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID].unresolved + allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID].resolved;
      }
    }
  });
  var activeNode; // If on a node currently, determine how many comments associated with that node

  if (assetData.nodeId !== undefined) {
    activeNode = allNodes[assetData.nodeId] || _objectSpread({}, initCount);
  } else {
    activeNode = total;
  }

  var usingGlobalComments = globalComments && isGlobalCommentsToggleActive;

  if (!anyFilterEnabled) {
    if (usingGlobalComments) {
      var _allNodes$UNMAPPED_GL, _allNodes$UNMAPPED_GL2;

      visible = _objectSpread({}, total);
      visible.unresolved += ((_allNodes$UNMAPPED_GL = allNodes[_constants.UNMAPPED_GLOBAL_ID]) === null || _allNodes$UNMAPPED_GL === void 0 ? void 0 : _allNodes$UNMAPPED_GL.unresolved) || 0;
      visible.total += ((_allNodes$UNMAPPED_GL2 = allNodes[_constants.UNMAPPED_GLOBAL_ID]) === null || _allNodes$UNMAPPED_GL2 === void 0 ? void 0 : _allNodes$UNMAPPED_GL2.total) || 0;
    } else {
      visible = _objectSpread({}, activeNode);
    }

    visible.total -= visible.resolved;
    visible.resolved = 0;
  }

  if (anyFilterEnabled) {
    if (assetData.nodeId !== undefined && !usingGlobalComments) {
      var _allNodesWithFilters$, _allNodesWithFilters$2, _allNodesWithFilters$3, _allNodesWithFilters$4, _allNodesWithFilters$5, _allNodesWithFilters$6;

      visible.resolved = (((_allNodesWithFilters$ = allNodesWithFilters[assetData.nodeId]) === null || _allNodesWithFilters$ === void 0 ? void 0 : _allNodesWithFilters$.resolved) || 0) + (((_allNodesWithFilters$2 = allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID]) === null || _allNodesWithFilters$2 === void 0 ? void 0 : _allNodesWithFilters$2.resolved) || 0);
      visible.unresolved = (((_allNodesWithFilters$3 = allNodesWithFilters[assetData.nodeId]) === null || _allNodesWithFilters$3 === void 0 ? void 0 : _allNodesWithFilters$3.unresolved) || 0) + (((_allNodesWithFilters$4 = allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID]) === null || _allNodesWithFilters$4 === void 0 ? void 0 : _allNodesWithFilters$4.unresolved) || 0);
      visible.total = (((_allNodesWithFilters$5 = allNodesWithFilters[assetData.nodeId]) === null || _allNodesWithFilters$5 === void 0 ? void 0 : _allNodesWithFilters$5.total) || 0) + (((_allNodesWithFilters$6 = allNodesWithFilters[_constants.UNMAPPED_GLOBAL_ID]) === null || _allNodesWithFilters$6 === void 0 ? void 0 : _allNodesWithFilters$6.total) || 0);
    }
  }

  return {
    allNodes: allNodes,
    activeNode: activeNode,
    total: total,
    visible: visible
  };
});
/**
 * Function to return a derived state of the existance of resolved comments
 * @returns {boolean} indication if at least one resolved comment is present
 */

exports.getCommentCounts = getCommentCounts;
var getHasResolvedComments = (0, _reselect.createSelector)([getAssetData, getComments, getGlobalComments], function (assetData, comments, globalComments) {
  var filteredComments = comments ? comments.concat([]) : [];

  if (!globalComments) {
    if (assetData.nodeId !== undefined) {
      filteredComments = filteredComments.filter(function (itm) {
        return assetData.nodeId === (0, _lodash.default)(itm, 'target.selector.node.id');
      });
    }
  }

  return filteredComments.findIndex(function (cmt) {
    return cmt.status === 'resolved';
  }) >= 0;
});
exports.getHasResolvedComments = getHasResolvedComments;